import apiClient from '../api/client';
import type {
  SessionSummary,
  SessionFullDetail,
  AggregateData,
  InsightsData,
} from '../types/analyticstypes';

interface RangeParams {
  from: string;
  to: string;
  deviceId?: string;
  storeNumber?: string;
}

export async function getStores(): Promise<string[]> {
  const response = await apiClient.get<string[]>('/api/Analytics/Stores');
  return response.data;
}

export async function getSessions(params: RangeParams): Promise<SessionSummary[]> {
  const response = await apiClient.get<SessionSummary[]>(
    '/api/Analytics/Sessions',
    { params: stripEmpty(params) }
  );
  return response.data;
}

export async function getSessionDetail(
  sessionId: string,
  guid?: string
): Promise<SessionFullDetail> {
  const response = await apiClient.get<SessionFullDetail>(
    `/api/Analytics/Sessions/${encodeURIComponent(sessionId)}`,
    { params: guid ? { guid } : undefined }
  );
  return response.data;
}

export async function getAggregate(
  params: RangeParams & { route?: string }
): Promise<AggregateData> {
  const response = await apiClient.get<AggregateData>(
    '/api/Analytics/Aggregate',
    { params: stripEmpty(params) }
  );
  return response.data;
}

export async function getInsights(params: RangeParams): Promise<InsightsData> {
  const response = await apiClient.get<InsightsData>(
    '/api/Analytics/Insights',
    { params: stripEmpty(params) }
  );
  return response.data;
}

function stripEmpty<T extends object>(obj: T): Partial<T> {
  const out: Partial<T> = {};
  for (const [k, v] of Object.entries(obj)) {
    if (v !== undefined && v !== null && v !== '') {
      (out as Record<string, unknown>)[k] = v;
    }
  }
  return out;
}
